import React from 'react'
import { Formik } from 'formik'
import { Form, Spinner } from 'react-bootstrap'
import Button from 'react-bootstrap/Button';

function NewsLetter() {

    const [ loading, setLoading ] = React.useState(false);
    const [ success, setSuccess ] = React.useState(null);

    return (
        <>
        <div style={{ marginTop: '20px', width: "60%", maxWidth: "600px", marginLeft: "auto", marginRight: "auto", minWidth: "300px" }}>
            <h2>Hírlevél feliratkozás</h2>
            <p>Iratkozzon fel hírlevelünkre, hogy elsőként értesüljön legfrissebb híreinkről és eseményeinkről!</p>
        <Formik
          initialValues={{ email: '', name: '' }}
          onSubmit={(values) => {
            setLoading(true);
            fetch(process.env.REACT_APP_LISTMONK_URL + '/subscription/form', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: new URLSearchParams(
                {
                    l: process.env.REACT_APP_LISTMONK_TARGET_UUID,
                    ...values
                }
              ).toString(),
            })
              .then((response) => {
                setLoading(false);
                if (response.ok) {
                  setSuccess(true);
                } else {
                  setSuccess(false);
                }
                return response.json();
              })
              .then((data) => {
                console.log('Success:', data);
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          }}
          validate={(values) => {
            const errors = {};
            if (!values.email) {
              errors.email = 'Ezen mező megadása kötelező!';
            }
            if (!values.name) {
              errors.name = 'Ezen mező megadása kötelező!';
            }
            if (values.name.length > 50 || values.name.length < 2) {
                errors.name = 'A név nem lehet hosszabb 50 karakternél és rövidebb 2 karakternél!';
            }
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = 'Érvénytelen email cím!';
            }
            if (values.email.split('@')[0].length > 64 || values.email.split('@')[0].length < 3) {
                errors.email = 'Az email cím első része nem lehet hosszabb 64 karakternél és rövidebb 3 karakternél!';
            }
            return errors;
          }}
        >
          {({ handleChange, handleSubmit, errors, touched, values }) => (
            <Form onSubmit={handleSubmit}>
                <p style={{ textAlign: "left", marginBottom: 0}}>Email cím</p>
                <Form.Control
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email && touched.email} 
                />
                <Form.Text className="text-danger">
                  {errors.email && touched.email && errors.email}
                </Form.Text>
              <Form.Group controlId="formName">
                <p style={{ textAlign: "left", marginTop: '10px', marginBottom: 0 }}>Név</p>
                <Form.Control
                  type="text"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  isInvalid={!!errors.name && touched.name}
                />
                <Form.Text className="text-danger">
                  {errors.name && touched.name && errors.name}
                </Form.Text>
              </Form.Group>
              <Button variant="outline-dark" type="submit" style={{ marginTop: 20 }}><i className='fa-solid fa-user' style={{ marginRight: 5}} />{ loading ? <Spinner display="inline" animation="border" size="sm" /> : <p style={{ display: 'inline' }}>Feliratkozás</p> }</Button>
              {
                success === true && <p style={{ marginTop: 10, color: 'green' }}>Sikeres feliratkozás!</p>
              }
              {
                success === false && <p style={{ marginTop: 10, color: 'red' }}>Hiba történt a feliratkozás során. Kérjük, próbálja újra később!</p>
              }
            </Form>
          )}
        </Formik>
        </div>
        </>
    )

}

export default NewsLetter


/*
email teszt@teszt.com
nonce
name Mikula Lajos
l c5861923-95f5-4b16-9614-29803202fef2*/